<template>
  <div class="grid grid-cols-2 gap-x-4 gap-y-1 mt-2 text-[11px]">
    <div class="flex items-center gap-1.5">
      <span
        class="inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
        :class="failed.min ? 'bg-[#D35400]' : 'bg-[#1EAB56]'"
      />
      <span :class="failed.min ? 'text-neutral-500' : 'text-neutral-400'">
        {{ $t('mycountly.validations.at-least-8-characters') }}
      </span>
    </div>
    <div class="flex items-center gap-1.5">
      <span
        class="inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
        :class="failed.max ? 'bg-[#D35400]' : 'bg-[#1EAB56]'"
      />
      <span :class="failed.max ? 'text-neutral-500' : 'text-neutral-400'">
        {{ $t('mycountly.validations.max-32-characters') }}
      </span>
    </div>
    <div class="flex items-center gap-1.5">
      <span
        class="inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
        :class="failed.one_uppercase ? 'bg-[#D35400]' : 'bg-[#1EAB56]'"
      />
      <span :class="failed.one_uppercase ? 'text-neutral-500' : 'text-neutral-400'">
        {{ $t('mycountly.validations.one_uppercase') }}
      </span>
    </div>
    <div class="flex items-center gap-1.5">
      <span
        class="inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
        :class="failed.one_lowercase ? 'bg-[#D35400]' : 'bg-[#1EAB56]'"
      />
      <span :class="failed.one_lowercase ? 'text-neutral-500' : 'text-neutral-400'">
        {{ $t('mycountly.validations.one_lowercase') }}
      </span>
    </div>
    <div class="flex items-center gap-1.5">
      <span
        class="inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
        :class="failed.one_number ? 'bg-[#D35400]' : 'bg-[#1EAB56]'"
      />
      <span :class="failed.one_number ? 'text-neutral-500' : 'text-neutral-400'">
        {{ $t('mycountly.validations.one_number') }}
      </span>
    </div>
    <div class="flex items-center gap-1.5">
      <span
        class="inline-block w-1.5 h-1.5 rounded-full flex-shrink-0"
        :class="failed.one_special ? 'bg-[#D35400]' : 'bg-[#1EAB56]'"
      />
      <span :class="failed.one_special ? 'text-neutral-500' : 'text-neutral-400'">
        {{ $t('mycountly.validations.one_special') }} (#?!@$%^&*-.:)
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordValidation',
  props: {
    failed: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
